module.exports = __webpack_public_path__ + "img/notifi-info.9ac665fa.svg";